import React, { useState } from "react";
import { Grid } from "@mui/material";
import styled from "styled-components";
import { ReactSVG } from "react-svg";
import { toast } from "react-toastify";

import Modal from "../../../../../components/Modal";
import api from "../../../../../services/api";
import FrontCredito from "../../../../../assets/navbar/Front_Credito_on_light_blue.svg";
import SearchableSelect from "../../../../../components/SearchableSelect";
import Input from "../../Input";
import Button from "../../../../../components/Button-v2";
import { Card, Label } from "../../styles";

const selectLabelStyles = {
  paddingBottom: "3.3px",
  lineHeight: 1.17,
  fontWeight: "normal",
  fontSize: "12px",
  opacity: 0.9,
};

const StatusModal = (props) => {
  const { open, onClose, status, statusLoading, statusTypes, reloadStatus } =
    props;

  const [selectedStatusModal, setSelectedStatusModal] = useState(undefined);
  const [selectedStatus, setSelectedStatus] = useState(undefined);
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setSelectedStatusModal(undefined);
    onClose();
  };

  const saveOpinion = () => {
    const data = {};

    setLoading(true);
    api
      .post(`/api/front-credito/pareceres`, data)
      .then(() => {
        toast.success("Dados salvos com sucesso!");
        reloadStatus();
        handleClose();
      })
      .catch(() => {
        toast.error("Erro ao salvar os dados.");
      })
      .finally(() => setLoading(false));
  };

  const disableButton = !selectedStatusModal;

  return (
    <Modal open={open} onClose={handleClose}>
      <Header>
        <IconWrapper>
          <ReactSVG src={FrontCredito} />
        </IconWrapper>
        <TitleWrapper>
          <Title>Front de crédito</Title>
          <Subtitle>Análise de Crédito</Subtitle>
        </TitleWrapper>
      </Header>
      <Body>
        <Label>Troca de status</Label>
        <Card>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Input
                color="#f6f6f6"
                label="Proposta"
                loading={loading}
                value={note}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                color="#f6f6f6"
                label="CPF/CNPJ"
                loading={loading}
                value={note}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <Input
                label="Nome do cliente"
                align="flex-start"
                type="textarea"
                loading={loading}
                value={note}
              />
            </Grid>
            <Grid item md={12}>
              <SearchableSelect
                entries={statusTypes}
                label="Alterar para"
                labelStyles={selectLabelStyles}
                parser={(it) => ({
                  value: it.codigo,
                  label: `${it.codigo} - ${it.descricao}`,
                })}
                placeholder="Selecione a opção desejada"
                selected={selectedStatus}
                setSelected={setSelectedStatus}
              />
            </Grid>
            <Grid item md={12}>
              <Input
                label="Motivos"
                value={note}
                disabled={loading}
                onChange={setNote}
                defaultValue=""
                height={200}
                type="textarea"
                align="flex-start"
              />
            </Grid>
            <ButtonWrapper>
              <Button
                height="34px"
                width="150px"
                loading={loading}
                disabled={disableButton}
                onClick={saveOpinion}
              >
                Alterar status
              </Button>
            </ButtonWrapper>
          </Grid>
        </Card>
      </Body>
    </Modal>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: row;

  border-bottom: 3px solid #00a2e0;
`;

const IconWrapper = styled.div`
  width: 50px;
  height: 50px;

  svg {
    width: 50px;
    height: 50px;
  }
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: space-between;

  margin: 0px 5px;
`;

const Title = styled.div`
  font-size: 18px;
  font-family: Roboto;
  font-weight: bold;
  line-height: 1.22;
  color: #383838;
`;

const Subtitle = styled.div`
  font-size: 15px;
  font-family: Roboto;
  font-weight: 500;
  line-height: 1.2;
  color: #747576;
`;

const Body = styled.div`
  margin-top: 32px;
  width: 700px;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  width: 100%;

  margin-top: 32px;
`;

export default StatusModal;
